import { EkonomiskAnalysEditColumnFormValuesType } from '../Components/EkonomiskAnalysEditColumnForm';
import { ekanalys_ekanalys_columns } from '../../../../../../Queries/EkonomiskAnalysSettingsQuery/_QueryTypes/ekanalys';
import { StandardColumnType } from '../Components/Queries/EkonomiskAnalysStandardColumnQuery/EkonomiskAnalysStandardColumnQuery';
import { findStandardColumnByFaltkod } from './EkonomiskAnalysEditColumnUtils';
import Logger, {
  namedError,
} from '../../../../../../../../../../../Utils/Logger';
import { IEkonomiskAnalysDates } from '../../../../../AnalysSettingsHandler/AnalysSettingsHandler';
import { getReferenceDates } from './EkonomiskAnalysConvertColumnToEditColumnFormValues';

/** Converts a year or period, If isRelative is true, converts the time to a diff from referenceTime */
const convertTime = (
  isRelative: boolean,
  referenceTime: number,
  time: number | null
): number | null => {
  if (time == null || !isRelative) {
    return time;
  } else {
    return time - referenceTime;
  }
};

/**
 * Converts a editColumnFormValues object to a column object by merging formvalues with the column that is being edited
 *
 * @param formValues The form values object to be converted
 * @param initialColumn The column that is being edited
 */
export const editColumnFormValuesToColumn = (
  formValues: EkonomiskAnalysEditColumnFormValuesType,
  initialColumn: ekanalys_ekanalys_columns,
  standardColumns: StandardColumnType[],
  referenceDates: IEkonomiskAnalysDates
): ekanalys_ekanalys_columns => {
  const fromArRelativ = !formValues.fromArChecked;
  const tomArRelativ = !formValues.tomArChecked;
  const fromPeriodRelativ = !formValues.fromPeriodChecked;
  const tomPeriodRelativ = !formValues.tomPeriodChecked;

  const standardColumn = findStandardColumnByFaltkod(
    formValues.columnOrigin,
    standardColumns
  );

  if (standardColumn == null && formValues.columnOrigin != null) {
    Logger.warn(
      namedError(
        'EkonomiskAnalysConvertEditColumnFormValuesToColum-CouldNotFindStandardColumn',
        `Could not find standardColumn with fältkod: ${formValues.columnOrigin}`
      )
    );
  }

  let { fromYear, fromMonth, toYear, toMonth } =
    getReferenceDates(referenceDates);

  if (standardColumn && standardColumn.INGAENDE) {
    toMonth = fromMonth;
  }

  return {
    LOPNR: initialColumn.LOPNR,
    ORDNINGS_NR: initialColumn.ORDNINGS_NR,
    FALTKOD: formValues.columnOrigin,
    INTERN: initialColumn.INTERN,
    RESULTAT_TYP: initialColumn.RESULTAT_TYP,
    FALT_TYP: formValues.columnType,
    INTERVALL_TYP: formValues.timeInterval,
    BAS: initialColumn.BAS,
    ANTAL_DECIMALER: initialColumn.ANTAL_DECIMALER,
    VAND_TECKEN: formValues.flipSign,
    BENAMNING: formValues.title,
    BENAMNING2: formValues.subTitle,
    CODE_CAPTION: standardColumn != null ? standardColumn.RUBRIK : '',
    FROM_AR: convertTime(fromArRelativ, fromYear, formValues.fromAr),
    FROM_AR_RELATIV: fromArRelativ,
    TOM_AR: convertTime(tomArRelativ, toYear, formValues.tomAr),
    TOM_AR_RELATIV: tomArRelativ,
    FROM_PER: convertTime(fromPeriodRelativ, fromMonth, formValues.fromPeriod),
    FROM_PER_RELATIV: fromPeriodRelativ,
    TOM_PER: convertTime(tomPeriodRelativ, toMonth, formValues.tomPeriod),
    TOM_PER_RELATIV: tomPeriodRelativ,
    ENHET_ID: formValues.columnUnit,
    CategoryPath: initialColumn.CategoryPath,
    Mallkolumn: initialColumn.Mallkolumn,
    MallValidCategories: initialColumn.MallValidCategories,
    RULLANDE: formValues.rullande,
    RULLANDE_PERIOD_TYP: initialColumn.RULLANDE_PERIOD_TYP,
    RULLANDE_PERIOD_ANTAL: initialColumn.RULLANDE_PERIOD_ANTAL,
    BUDGETTYP: formValues.budgetType,
    BUDGETBENAMNING: formValues.budget,
    HIDE_COLUMN: initialColumn.HIDE_COLUMN,
    FORCE_CALCULATE: initialColumn.FORCE_CALCULATE,
    SPECIFIKATION: initialColumn.SPECIFIKATION,
    __typename: 'TEDAvenyEKAnalysColumn',
  };
};
